// Define the Server interface to type the server objects
interface Server {
  id: string;
  name: string;
  number: number;
  backgroundColor: string;
  textColor: string;
  borderColor: string;
}

// Define the SERVERS array with additional color properties
export const SERVERS: Server[] = [
  { id: 'west', name: 'Americas', number: 0, backgroundColor: '#73adf0', textColor: '#000080', borderColor: '#a80000' },
  { id: 'east', name: 'Asia', number: 1, backgroundColor: '#a9d9a9', textColor: '#004a00', borderColor: '#877201' },
  { id: 'europe', name: 'Europe', number: 2, backgroundColor: '#f5edba', textColor: '#753a0f', borderColor: '#13137d' },
];

// Helper function to find a server by parameter (id, name, or number)
function getServerByParam(param: string | number): Server | undefined {
  if (typeof param === 'string') {
    const lowerParam = param.toLowerCase();
    return SERVERS.find(
      (server) =>
        server.id.toLowerCase() === lowerParam ||
        server.name.toLowerCase() === lowerParam
    );
  } else if (typeof param === 'number') {
    return SERVERS.find((server) => server.number === param);
  }
  return undefined;
}

// Get the server ID based on a string (id or name) or number
export function getServerIdString(param: string | number): string | undefined {
  const server = getServerByParam(param);
  return server ? server.id : undefined;
}

// Get the server name based on a string (id or name) or number
export function getServerName(param: string | number): string {
  const server = getServerByParam(param);
  return server ? server.name : 'Unknown Server';
}

// Get the background color based on a string (id or name) or number
export function getServerBackgroundColor(param: string | number): string {
  const server = getServerByParam(param);
  return server ? server.backgroundColor : '#ffffff';
}

// Get the text color based on a string (id or name) or number
export function getServerTextColor(param: string | number): string {
  const server = getServerByParam(param);
  return server ? server.textColor : '#000000';
}

// Get the border color based on a string (id or name) or number
export function getServerBorderColor(param: string | number): string {
  const server = getServerByParam(param);
  return server ? server.borderColor : '#808080';
}

// Return all server objects
export function getAllServers(): Server[] {
  return SERVERS;
}